import React from 'react'
import {  FaArrowRight } from "react-icons/fa6";
function CTA() {
  const handleSubmit = (e) => {
    e.preventDefault(); // prevent the default form submission
    window.location.href = "https://calendly.com/chestersolutionoffpage/30min";
  };
  return (
    <>
      <div className="cta1-section-area sp1">
        <div className="container">
          <div className="row">
            {/* Left CTA Text */}
            <div className="col-lg-5">
              <div className="cta-header heading1">
                <h2>Transform Your IT Today - Speak with Our Experts!</h2>
                <div className="space16"></div>
                <p>
                  Ready to take your business to the next level with
                  cutting-edge IT solutions? Our team is here to help you
                  transform.
                </p>
                <div className="space24"></div>
                 <form onSubmit={handleSubmit}>
  <input type="text" placeholder="Book a Free Consultation" />
  <button type="submit" className="vl-btn1">
    Schedule a Call <FaArrowRight />
  </button>
</form>
              </div>
            </div>

            <div className="col-lg-3"></div>

            {/* CTA Right Image */}
            <div className="col-lg-4">
  <div className="cta-images">
    <img
      src="/assets/img/elements/elements7.png"
      alt=""
      className="elements7 keyframe5"
    />
    <div className="img1">
      <img src="/assets/img/all-images/cta/cta-img1.png" alt="" />
    </div>
    <ul className="aniamtion-key-1">
      <li>
        <a href="#">
          <img src="/assets/img/icons/check5.svg" alt="" /> IT Solution Services
        </a>
      </li>
      <li>
        <a href="#">
          <img src="/assets/img/icons/check5.svg" alt="" /> Cyber Security
          Services
        </a>
      </li>
      <li>
        <a href="#">
          <img src="/assets/img/icons/check5.svg" alt="" /> Software Development
        </a>
      </li>
    </ul>
  </div>
</div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CTA
